<template>
  <div>
    <div class="sideByDiv">
      <Input class="sideByLeft" placeholder="Delivery Note #" :isRequired="true" :inputValue.sync="data.deliveryNoteNo" :isDisabled="data.disabledDeliveryNoteNo" />
      <Input class="sideByRight" placeholder="Reference #" :inputValue.sync="data.refNo" :isDisabled="data.viewMode" />
    </div>
    <DateTimePicker title="Date/Time" :value.sync="data.deliveryDateTime"/>
    <div class="sideByDiv" style="padding:5px 0 5px 0">
      <div class="customBox">
        <div class="customBoxTitle">Lorry/Driver</div>
        <div>
          <InputQuery placeholder="Lorry No" :items="data.lorryNoItems" itemKey="Lorry No" descKey="Vehicle Code"
            :selectedObject.sync="data.selectedLorryNo" :isDisabled="data.viewMode" isRequired="true" />
          <InputQuery placeholder="Driver Code" :items="data.driverCodeItems" itemKey="Driver Code" descKey="Driver Name"
            :selectedObject.sync="data.selectedDriverCode" :isDisabled="data.viewMode" isRequired="true" 
            @selected="driverSelected"/>
          <Input placeholder="Driver Name" :isRequired="true" :inputValue.sync="data.driverName" :isDisabled="data.viewMode" />
          <Input placeholder="Driver IC" :inputValue.sync="data.driverIC" :isDisabled="data.viewMode" />
          <InputQuery placeholder="Transporter" :items="data.transItems" itemKey="Creditor Code" descKey="Creditor Name"
            :selectedObject.sync="data.selectedTrans" :isDisabled="data.viewMode" isRequired="true"/>
        </div>
      </div>
      <!--Job Details-->
      <div class="customBox">
        <div class="customBoxTitle">Job Details</div>
        <div>
          <Input placeholder="Job #" :inputValue.sync="data.jobNo" isDisabled=true />
          <Input placeholder="Date/Time" :inputValue.sync="data.dateTime" isDisabled=true />
          <Input placeholder="Customer" :inputValue.sync="data.cust" isDisabled=true />
          <Input placeholder="Voyage #" :inputValue.sync="data.vogNo" isDisabled=true />
          <Input placeholder="Vessel ETA" :inputValue.sync="data.vesETA" isDisabled=true />
        </div>
      </div>
      <!--Job Details-->
    </div>
    <RemarksBox title="Remarks" :text.sync="data.remarks" :maxLength="200" style="height: 50px" :isDisabled="data.viewMode" />
    <div class="customBox">
      <div class="customBoxDiv">
        <div class="sideByDiv">
          <div class="sideByLeft">
            <InputQuery placeholder="From" :items="data.destinationFromItems" itemKey="Destination Code" descKey="Company"
              :selectedObject.sync="data.selectedDestinationFrom" :isDisabled="data.viewMode" isRequired="true"
              @selected="updateDestArea('From')"/>
            <textarea class="addBox" :disabled="textAreaDisabled" v-model="data.fromText"></textarea>
            <!--<RemarksBox title="" style="height: 100px" />-->
            <div class="sideByDiv">
              <div class="sideByLeft">
                <Input placeholder="Qty" :isRequired="true" :inputValue.sync="data.qty" :isDisabled="data.viewMode" />
              </div>
              <div class="sideByRight">
                <InputQuery placeholder="Package" :items="data.packageCodeItems" itemKey="Package Code" descKey="Description"
                  :selectedObject.sync="data.selectedPackageCode" :isDisabled="data.viewMode" isRequired="true" />
              </div>
            </div>
            <RemarksBox title="Goods Description" :text.sync="data.goodsDesc" :maxLength="200" style="height: 100px" :isDisabled="data.viewMode"/>
          </div>
          <div class="sideByRight">
            <InputQuery placeholder="To" :items="data.destinationToItems" itemKey="Destination Code" descKey="Company"
              :selectedObject.sync="data.selectedDestinationTo" :isDisabled="data.viewMode" isRequired="true"
              @selected="updateDestArea('To')"/>
            <textarea class="addBox" :disabled="textAreaDisabled" v-model="data.toText"></textarea>
            <!--<RemarksBox title="" style="height: 100px" />-->
            <div class="sideByDiv">
              <div class="sideByLeft">
                <Input placeholder="KG" :isRequired="true" :inputValue.sync="data.kg" :isDisabled="data.viewMode" />
              </div>
              <div class="sideByRight">
                <Input placeholder="M3" :isRequired="true" :inputValue.sync="data.m3" :isDisabled="data.viewMode" />
              </div>
            </div>
            <RemarksBox title="Shipping Marks" :text.sync="data.shippingMarks" :maxLength="200" style="height: 100px" :isDisabled="data.viewMode"/>
          </div>
        </div>
      </div>
    </div>
    <!-- <div class="tabBox">
      <Tabulator class="tabtab" id="portTabulator" @rowSelected="destRow" :tableData="portList" :multiSelect="1" :selectedRow.sync="selectedPort" :currentPage.sync="destCurrentPage" :currentRowSize.sync="destCurrentRowSize" />
    </div> -->
  </div>
</template>

<script>
/* eslint-disable */
import Input from '@/components/Input.vue';
import InputQuery from '@/components/InputQuery.vue';
// import DateTimePicker from '@/components/DateTimePicker.vue';
import RemarksBox from '@/components/RemarksBox.vue';
import Dropdown from '@/components/Dropdown.vue';
import ItemListing from '@/components/ItemListing.vue';
import Tabulator from '@/components/Tabulator.vue';

export default {
  components: {
    Input, InputQuery, RemarksBox, Dropdown, ItemListing, Tabulator,
  },
  props: {
    data: { type: Object, default: function () { return {} } },
    // viewMode: { type: Boolean, default: false },

    //TextArea
    textAreaDisabled: { type: Boolean, default: true },
  },
  methods: {
    //DateTime Conversions
    convertDateTime: function (dateString, timeString) {
      var newDate = this.utcToDate(dateString);
      newDate = this.longToShortDate(newDate);

      var newDateTime = newDate.slice(0, 10);
      var time1 = timeString.slice(0, 2);
      var time2 = timeString.slice(2, 4);
      newDateTime = `${newDateTime} ${time1}:${time2}`;
      return newDateTime
    },
    utcToDate: function (dateString) {
      dateString = dateString.replace('/Date(', '');
      dateString = dateString.replace(')/', '');
      var d = new Date(0);
      d.setUTCMilliseconds(dateString);
      return d;
    },
    longToShortDate: function (longDate) {
      var d = longDate.getDate().toString();
      var m = longDate.getMonth() + 1;
      var y = longDate.getFullYear();
      var hh = longDate.getHours().toString();
      var mm = longDate.getMinutes().toString();

      d = (d.length < 2) ? 0 + d : d;
      m = m.toString();
      m = (m.length < 2) ? 0 + m : m;
      hh = (hh.length < 2) ? 0 + hh : hh;
      mm = (mm.length < 2) ? 0 + mm : mm;

      var formattedDate = `${d}/${m}/${y} ${hh}:${mm}`;
      return formattedDate;
    },
		//DateTime Conversions

    updateDestArea: function (or) {
      switch (or) {
        case 'From':
          this.data.fromText = this.data.selectedDestinationFrom.Address;
          break;
        case 'To':
          this.data.toText = this.data.selectedDestinationTo.Address;
          break;
      }
    },

    driverSelected: function () {
      this.data.driverName = this.data.selectedDriverCode['Driver Name'];
      this.data.driverIC = this.data.selectedDriverCode['Driver IC'];
    },
  },
  mounted() {
  },
  watch: {
		data: {
			deep: true,
      handler(val) {
			}
		},
  }
}
</script>

<style lang="scss" scoped>
@import '@/css/all.scss';

.sideByDiv {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}

.sideByLeft {
  padding-right: 5px;
}

.sideByRight {
  padding-left: 5px;
}

.sideByLeft, .sideByRight {
  width: 100%;
}

.customBox {
  border: 1px solid rgb(200,200,200);
  border-radius: 3px;
  width: 100%;
  position: relative;
  padding: 5px;
  margin: 5px 0 5px 0;
}

.customBoxTitle {
  font-size: 12px;
  width: auto;
  height: 20px;
  padding: 0 5px 0 5px;
  font-weight: bold;
  align-items: center;
  justify-content: center;
  top: -11px;
  left: 10px;
  position: absolute;
  background-color: #ffffffff;
}

.addBox {
  font-size: 12px;
  width: 100%;
  height: 80px;
}
</style>
